import { yupResolver } from "@hookform/resolvers/yup";
import type React from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
	DirectUploadStatusContext,
	useDirectUploadStatusProvider
} from "~/components/common/deals/new/DirectUploadStatusContext";
import type { Deal } from "~/models/Deal";
import type { RelatedDealParam } from "~/models/DealForm";
import { buildDealParam, relatedDealValidationSchema } from "~/models/DealForm";
import { DealEditorBody } from "./DealEditorBody";
import { DealEditorFooter } from "./DealEditorFooter";

type Props = {
	deal: Deal;
};

export const DealEditor: React.FC<Props> = ({ deal }) => {
	const directUploadStatus = useDirectUploadStatusProvider();
	const methods = useForm<RelatedDealParam>({
		defaultValues: buildDealParam({
			dealType: null,
			inspectionBy: "none",
			leasingId: null
		}),
		mode: "onBlur",
		resolver: yupResolver(relatedDealValidationSchema),
		shouldFocusError: false
	});
	return (
		<div>
			<FormProvider {...methods}>
				<DirectUploadStatusContext.Provider value={directUploadStatus}>
					<DealEditorBody deal={deal} />
					<DealEditorFooter deal={deal} />
				</DirectUploadStatusContext.Provider>
			</FormProvider>
		</div>
	);
};
